import { TransactionSourceType } from '@pflegenavi/shared/api';

import CancelLogo from '../assets/transaction-icons/cancel.svg';
import RefundGreenLogo from '../assets/transaction-icons/refund-green.svg';
import ClockLogo from '../assets/transaction-icons/clock.svg';

export const getTransactionSourceIcon = ({
  sourceType,
  cancelled,
}: {
  sourceType: TransactionSourceType;
  cancelled?: boolean;
}): { icon: string; color: string } => {
  if (cancelled) {
    return { icon: CancelLogo, color: 'error' };
  }
  if (sourceType === TransactionSourceType.CancelledReceipt) {
    return { icon: RefundGreenLogo, color: 'success' };
  }
  if (sourceType === TransactionSourceType.RecurringItem) {
    return {
      icon: ClockLogo,
      color: 'info',
    };
  }
  if (sourceType === TransactionSourceType.Receipt) {
    return {
      icon: '',
      color: '',
    };
  }
  return {
    icon: '',
    color: '',
  };
};
